import { __awaiter, __generator } from "tslib";
import * as lunr from 'lunr';
try {
    // tslint:disable-next-line
    require('core-js/es/promise'); // bundle into worker
}
catch (_) { } // nope
/* just for better typings */
var Worker = /** @class */ (function () {
    function Worker() {
        this.add = add;
        this.done = done;
        this.search = search;
        this.toJS = toJS;
        this.load = load;
        this.dispose = dispose;
    }
    return Worker;
}());
export default Worker;
var store = [];
lunr.tokenizer.separator = /\s+/;
var builder;
var resolveIndex;
var index;
function initEmpty() {
    builder = new lunr.Builder();
    builder.field('title');
    builder.field('description');
    builder.ref('ref');
    builder.pipeline.add(lunr.trimmer, lunr.stopWordFilter, lunr.stemmer);
    index = new Promise(function (resolve) {
        resolveIndex = resolve;
    });
}
initEmpty();
var expandTerm = function (term) { return '*' + lunr.stemmer(new lunr.Token(term, {})) + '*'; };
export function add(title, description, meta) {
    var ref = store.push(meta) - 1;
    var item = {
        title: title.toLowerCase(),
        description: description.toLowerCase(),
        ref: ref
    };
    builder.add(item);
}
export function done() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            resolveIndex(builder.build());
            return [2 /*return*/];
        });
    });
}
export function toJS() {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = {
                        store: store
                    };
                    return [4 /*yield*/, index];
                case 1: return [2 /*return*/, (_a.index = (_b.sent()).toJSON(),
                        _a)];
            }
        });
    });
}
export function load(state) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            store = state.store;
            resolveIndex(lunr.Index.load(state.index));
            return [2 /*return*/];
        });
    });
}
export function dispose() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            store = [];
            initEmpty();
            return [2 /*return*/];
        });
    });
}
export function search(q, limit) {
    if (limit === void 0) { limit = 0; }
    return __awaiter(this, void 0, void 0, function () {
        var searchResults;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (q.trim().length === 0) {
                        return [2 /*return*/, []];
                    }
                    return [4 /*yield*/, index];
                case 1:
                    searchResults = (_a.sent()).query(function (t) {
                        q.trim().toLowerCase().split(/\s+/).forEach(function (term) {
                            var exp = expandTerm(term);
                            t.term(exp, {});
                        });
                    });
                    if (limit > 0) {
                        searchResults = searchResults.slice(0, limit);
                    }
                    return [2 /*return*/, searchResults.map(function (res) { return ({
                            meta: store[res.ref],
                            score: res.score
                        }); })];
            }
        });
    });
}

addEventListener('message', e => {let {type,method,id,params} = e.data,f,p;if (type === 'RPC' && method) {if (f = __webpack_exports__[method]) {p = Promise.resolve().then(() => f.apply(__webpack_exports__, params));} else {p = Promise.reject('No such method');}p.then(result => {postMessage({type: 'RPC',id,result});}).catch(e => {let error = {message: e};if (e.stack) {error.message = e.message;error.stack = e.stack;error.name = e.name;}postMessage({type: 'RPC',id,error});});}});postMessage({type: 'RPC',method: 'ready'});